
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sales",
      function () {
        return require("private-next-pages/sales.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sales"])
      });
    }
  